import {useEffect, useState} from 'react';

import {B2BOrderItem} from '@buncha/home/types';
import {OrderItemStatus} from '@buncha/batchDetails/types';
import {cloneDeep} from 'lodash';

const initialValue: Partial<{[key in OrderItemStatus]: B2BOrderItem[]}> = {
  [OrderItemStatus.picked]: [],
  [OrderItemStatus.missing]: [],
  [OrderItemStatus.dropped]: [],
  [OrderItemStatus.notPicked]: [],
};

export function useItemsGrouping(orderItems: B2BOrderItem[]) {
  const [groupedItems, setGroupedItems] = useState(initialValue);

  const groupItemsByStatus = () => {
    const items = cloneDeep(initialValue);

    for (const item of orderItems) {
      const isSubstituted =
        Boolean(item?.parentItemId?.length) &&
        [OrderItemStatus.picked, OrderItemStatus.packed].includes(item.status);
      if (isSubstituted) items[OrderItemStatus.missing]?.push(item);
      else if (
        item.status === OrderItemStatus.picked ||
        item.status === OrderItemStatus.packed ||
        item.status === OrderItemStatus.notPacked
      )
        items[OrderItemStatus.picked]?.push(item);
      else if (item.status === OrderItemStatus.dropped)
        items[OrderItemStatus.dropped]?.push(item);
      else if (item.status === OrderItemStatus.notPicked)
        items[OrderItemStatus.notPicked]?.push(item);
    }

    setGroupedItems(items);
  };

  useEffect(() => {
    groupItemsByStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderItems]);

  return groupedItems;
}
